export default "__VITE_ASSET__1ik33HU2__"